export enum AddressTypeEnum {
  AddressDutch = 'AddressDutch',
  AddressInternational = 'AddressInternational'
}
